export default "__VITE_ASSET__D7MZmU51__"